export function formatNearest50(n?: number): string {
  if (!n) return ''
  if (n <= 50) return n.toString()
  if (n % 50 === 0) return n.toString()
  return `${Math.floor(n / 50) * 50}+`
}

export function niceNumber(n: number): string | null {
  if (!n) return null
  const parts = n.toString().split('.')
  return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? `.${parts[1]}` : '')
}
